import { gql } from '@apollo/client';

export const fetchChannelTypesQuery = gql`
  query getChannelTypes {
    channelTypes
  }
`;

export const fetchMessageMediumsQuery = gql`
  query getMessageMediums {
    messageMediums
  }
`;

export type User = {
  id: string;
  fullName: string;
  avatarUrl: string;
};

export type FetchTemplatesMetaQueryResult = {
  templateCreators: User[];
  templateModifiers: User[];
};

export const fetchTemplatesMetaQuery = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query getTemplateMeta {
    templateCreators {
      ...userInfo
    }
    templateModifiers {
      ...userInfo
    }
  }
`;

export const fetchTemplatesQuery = gql`
  fragment templatesPageInfo on Templates {
    info {
      count
      limit
      offset
      page
    }
  }

  query getTemplates(
    $filter: TemplateFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    templates(filterInfo: $filter, pagination: $pagination, sort: $sort, search: $search) {
      ...templatesPageInfo
      results {
        id
        contentPreview
        createdAt
        createdByUserId
        locales {
          languageName
          tag
        }
        messageMedium
        name
        updatedAt
        updatedByUserId
      }
    }
  }
`;

export const fetchDynamicSenderProjectSetting = gql`
  query getCurrentProject {
    currentProject {
      useDynamicSenders
    }
  }
`;

export const fetchPlacementsQuery = gql`
  query fetchPlacements {
    placements(nonArchivedOnly: true) {
      payload {
        id
        fields {
          placementName
        }
      }
    }
  }
`;

export const fetchTemplateTypeAndLocalesQuery = gql`
  query getTemplateTypeAndLocales($id: Long!) {
    templateAndContent(id: $id) {
      ... on TemplateAndContent {
        templateType
        localeContents {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            metaApprovalStatus
          }
        }
      }
    }
  }
`;

export const fetchTemplateApprovalStatuesByLocale = gql`
  query getTemplateApprovalStatuesByLocale($id: Long!) {
    templateAndContent(id: $id) {
      ... on TemplateAndContent {
        primaryContent {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            metaApprovalStatus
            qualityRating
          }
        }
        localeContents {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            metaApprovalStatus
            qualityRating
          }
        }
      }
    }
  }
`;

export const fetchTemplateHandlebars = gql`
  query getHandlebars($template: StructureDefinitionInput!){
    templatePlaceholders(template: $template) {
      placeholders
    }
  }
`;

export const fetchWhatsAppTemplateMetadataByLocale = gql`
  query getWhatsAppTemplateMetadataByLocale($id: Long!) {
    templateAndContent(id: $id) {
      ... on TemplateAndContent {
        primaryContent {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            whatsAppSender {
              status
              sendLimit
            }
            metaApprovalStatus
            qualityRating
          }
        }
        localeContents {
          ... on WhatsAppContentDefinition {
            locale {
              name
            }
            whatsAppSender {
              status
              sendLimit
            }
            metaApprovalStatus
            qualityRating
          }
        }
      }
    }
  }
`;

export const fetchShortLinksMinimumLengthQuery = gql`
  query getShortLinksMarketingMinimumLength {
    getShortLinksMarketingMinimumLength
    getShortLinksTransactionalMinimumLength
  }
`;
